import { all, call, fork, put, takeEvery } from "redux-saga/effects";

import { SEND_MY_CURRENT_LOCATION } from "./actionType";

// success failure actions
import {
  sendMyCurrentLocationSuccess,
  sendMyCurrentLocationFailure,
} from "./action";

// api
import { sendMyCurrentLocationApi } from "../../helpers/fakebackend_helper";

// send my current location
function* sendMyCurrentLocationSaga({ payload }) {
  try {
    const response = yield call(sendMyCurrentLocationApi, payload);
    yield put(sendMyCurrentLocationSuccess(response));
  } catch (error) {
    yield put(sendMyCurrentLocationFailure(error));
  }
}

// watch saga
export function* watchSendMyCurrentLocationSaga() {
  yield takeEvery(SEND_MY_CURRENT_LOCATION, sendMyCurrentLocationSaga);
}

function* GPS() {
  yield all([fork(watchSendMyCurrentLocationSaga)]);
}

export default GPS;
